import { zSchema } from "@zeal/common";

export const deleteNetPayDuplicateBankAccountSuppressionRequestSchema =
  zSchema.object({
    account_and_routing_number: zSchema.string(),
    workerIDs: zSchema.array(zSchema.string()),
  });

export type TDeleteNetPayDuplicateBankAccountSuppressionRequest = zSchema.infer<
  typeof deleteNetPayDuplicateBankAccountSuppressionRequestSchema
>;

export const deleteNetPayDuplicateBankAccountSuppressionResponseSchema =
  zSchema.object({
    account_and_routing_number: zSchema.string(),
    deleted: zSchema.boolean(),
    removedWorkerIDs: zSchema.array(zSchema.string()),
    remainingWorkerIDs: zSchema.array(zSchema.string()),
  });

export type TDeleteNetPayDuplicateBankAccountSuppressionResponse =
  zSchema.infer<
    typeof deleteNetPayDuplicateBankAccountSuppressionResponseSchema
  >;
